import { render, staticRenderFns } from "./IconBulkReturn.vue?vue&type=template&id=30a2bef1&scoped=true"
import script from "./IconBulkReturn.vue?vue&type=script&lang=js"
export * from "./IconBulkReturn.vue?vue&type=script&lang=js"
import style0 from "./IconBulkReturn.vue?vue&type=style&index=0&id=30a2bef1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a2bef1",
  null
  
)

export default component.exports